import React from 'react';
import { ClockIcon } from '@heroicons/react/24/outline';

interface QuizHeaderProps {
  subjectName: string;
  progress: number;
  currentQuestion: number;
  totalQuestions: number;
  timeSpent: number;
}

export const QuizHeader: React.FC<QuizHeaderProps> = ({
  subjectName,
  progress,
  currentQuestion,
  totalQuestions,
  timeSpent
}) => {
  const formatTime = (milliseconds: number) => {
    const seconds = Math.floor(milliseconds / 1000);
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-40">
      <div className="px-4 py-3">
        {/* Materia e timer */}
        <div className="flex justify-between items-center mb-3">
          <h1 className="text-lg font-semibold text-gray-900 truncate">{subjectName}</h1>
          <div className="flex items-center space-x-2 text-sm text-gray-600 flex-shrink-0">
            <ClockIcon className="h-4 w-4" />
            <span className="font-mono">{formatTime(timeSpent)}</span>
          </div>
        </div>

        {/* Barra progresso */}
        <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
          <div 
            className="bg-primary-600 h-2 rounded-full transition-all duration-300 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>

        {/* Contatore domande */}
        <div className="flex justify-between items-center text-sm text-gray-600">
          <span>Domanda {currentQuestion} di {totalQuestions}</span>
          <span className="font-medium">{Math.round(progress)}%</span>
        </div>
      </div>
    </div>
  );
};
